/**
 * CompanyAdminGuard
 *
 * Ensures routes that expose company wide settings are accessible only to
 * authenticated users who hold the `company-admin` role. If the user is
 * authenticated but is not a company admin, the guard redirects the user to
 * the NotFound route. Otherwise the guard renders the `ProtectedGuard` to
 * enforce authentication and render the children.
 */
import { Navigate } from 'react-router';

import { useAuth } from '../hooks/auth/useAuth';
import { AppRoutes } from '../shared/enums/app-routes';
import ProtectedGuard from './ProtectedGuard';

type CompanyAdminGuardProps = {
  children: React.ReactNode;
};

const CompanyAdminGuard = ({ children }: CompanyAdminGuardProps) => {
  const { isAuthenticated, isCompanyAdmin, isBasfSuperAdmin } = useAuth();

  if (isAuthenticated && !isCompanyAdmin && !isBasfSuperAdmin) {
    return <Navigate to={AppRoutes.NotFound} replace={true} />;
  }

  return <ProtectedGuard>{children}</ProtectedGuard>;
};

export default CompanyAdminGuard;
